/* istanbul ignore file */

import React from 'react';
import {
  IconPaymentAmex,
  IconPaymentApplePay,
  IconPaymentGooglePay,
  IconPaymentKlarna,
  IconPaymentMastercard,
  IconPaymentPayPal,
  IconPaymentVisa,
} from '@noths/polaris-client-ribbons-design-system';

import * as styles from './FooterPayment.styles';

export const FooterPayment = () => (
  <div>
    <span css={styles.screenReaderOnly}>Available payment methods:</span>
    <ul css={styles.list}>
      <li>
        <IconPaymentVisa height="32" width="50" />
      </li>
      <li>
        <IconPaymentMastercard height="32" width="50" />
      </li>
      <li>
        <IconPaymentAmex height="32" width="50" />
      </li>
      <li>
        <IconPaymentPayPal height="32" width="50" />
      </li>
      <li>
        <IconPaymentApplePay height="32" width="50" />
      </li>
      <li>
        <IconPaymentGooglePay height="32" width="50" />
      </li>
      <li>
        <IconPaymentKlarna height="32" width="50" />
      </li>
    </ul>
  </div>
);
